import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div``;

const ErrorBoundaryPage = () => {
  return (
    <Container>
      <Outlet />
    </Container>
  );
};

export default ErrorBoundaryPage;
